import React from 'react'
import { Redirect } from 'react-router-dom'
import { PROJECT_TYPE } from 'app/constants'
import { PERMISSIONS } from 'permissions'

const pagesRoutes = [
  {
    exact: true,
    path: '/projects',
    component: React.lazy(() => import('./projects/ProjectList')),
  },
  {
    exact: true,
    path: `/prediction-projects`,
    component: () => <Redirect to={`/projects?type=${PROJECT_TYPE.PREDICTION}`} />,
  },
  {
    exact: true,
    path: `/clustering-projects`,
    component: () => <Redirect to={`/projects?type=${PROJECT_TYPE.CLUSTERING}`} />,
  },
  {
    path: '/new-project',
    component: React.lazy(() => import('./projects/ProjectForm')),
  },
  {
    exact: true,
    path: '/projects/:id',
    component: React.lazy(() => import('./projects/ProjectViewer')),
  },
  {
    path: '/projects/:id/edit',
    component: React.lazy(() => import('./projects/ProjectForm')),
  },
  {
    path: '/projects/:id/read-only',
    component: React.lazy(() => import('./projects/ProjectForm')),
  },
  {
    exact: true,
    path: '/folders',
    component: React.lazy(() => import('./folders/FolderList')),
  },
  {
    path: '/new-folder',
    component: React.lazy(() => import('./folders/FolderForm')),
  },
  {
    exact: true,
    path: '/folders/:id',
    component: React.lazy(() => import('./folders/FolderViewer')),
  },
  {
    path: '/folders/:id/edit',
    component: React.lazy(() => import('./folders/FolderForm')),
  },
  {
    exact: true,
    path: '/datasets',
    component: React.lazy(() => import('./datasets/DatasetList')),
  },
  {
    path: '/new-dataset',
    component: React.lazy(() => import('./datasets/DatasetForm')),
  },
  {
    exact: true,
    path: '/datasets/:id',
    component: React.lazy(() => import('./datasets/DatasetViewer')),
  },
  {
    path: '/datasets/:id/edit',
    component: React.lazy(() => import('./datasets/DatasetForm')),
  },
  {
    path: '/datasets/:id/read-only',
    component: React.lazy(() => import('./datasets/DatasetForm')),
  },
  {
    exact: true,
    path: '/predictors',
    component: React.lazy(() => import('./predictors/PredictorList')),
  },
  {
    path: '/new-predictor',
    component: React.lazy(() => import('./predictors/PredictorForm')),
  },
  {
    exact: true,
    path: '/predictors/:id',
    component: React.lazy(() => import('./predictors/PredictorViewer')),
  },
  {
    path: '/predictors/:id/edit',
    component: React.lazy(() => import('./predictors/PredictorForm')),
  },
  {
    path: '/predictors/:id/read-only',
    component: React.lazy(() => import('./predictors/PredictorForm')),
  },
  {
    path: '/change-password',
    component: React.lazy(() => import('./user-management/ChangePassword')),
  },
  {
    path: '/change-phone-number',
    component: React.lazy(() => import('./user-management/ChangePhoneNumber')),
  },
  {
    path: '/change-mfa-device',
    component: React.lazy(() => import('./user-management/ChangeMFADevice')),
  },
  {
    exact: true,
    path: '/mpo-projects',
    component: React.lazy(() => import('./mpoProjects/MpoProjectList')),
  },
  {
    path: '/new-mpo-project',
    component: React.lazy(() => import('./mpoProjects/MpoProjectForm')),
  },
  {
    exact: true,
    path: '/mpo-projects/:id',
    component: React.lazy(() => import('./mpoProjects/MpoProjectViewer')),
  },
  {
    path: '/mpo-projects/:id/edit',
    component: React.lazy(() => import('./mpoProjects/MpoProjectForm')),
  },
  {
    path: '/mpo-projects/:id/read-only',
    component: React.lazy(() => import('./mpoProjects/MpoProjectForm')),
  },
  {
    path: '/novo-design',
    component: React.lazy(() => import('./novoDesign/NovoDesign')),
    scopes: [PERMISSIONS.USE_INTERACTIVE_DESIGN]
  },
  {
    exact: true,
    path: '/file-storage',
    component: React.lazy(() => import('./file-storage/FileStorageList')),
    scopes: [PERMISSIONS.FILE_STORAGE_VIEW]
  },
  {
    path: '/new-file-storage',
    component: React.lazy(() => import('./file-storage/FileStorageForm')),
    scopes: [PERMISSIONS.FILE_STORAGE_CREATE]
  },
  {
    exact: true,
    path: '/file-storage/:id',
    component: React.lazy(() => import('./file-storage/components/FileStorageViewer')),
    scopes: [PERMISSIONS.FILE_STORAGE_VIEW]
  },
  {
    exact: true,
    path: '/file-storage/:id/edit',
    component: React.lazy(() => import('./file-storage/FileStorageForm')),
    scopes: [PERMISSIONS.FILE_STORAGE_UPDATE]
  },
  {
    exact: true,
    path: '/del-report',
    component: React.lazy(() => import('./del-report/DelReportList')),
    scopes: [PERMISSIONS.DEL_DELIVERY_VIEW]
  },
  {
    exact: true,
    path: '/del-report/:id',
    component: React.lazy(() => import('./file-storage/components/FileStorageViewer')),
    scopes: [PERMISSIONS.DEL_DELIVERY_VIEW]
  },
  {
    exact: true,
    path: '/new-del-report',
    component: React.lazy(() => import('./file-storage/FileStorageForm')),
    scopes: [PERMISSIONS.FILE_STORAGE_CREATE]
  },
  {
    exact: true,
    path: '/workflow',
    component: React.lazy(() => import('./workflow/Workflow')),
  },
  {
    exact: true,
    path: '/workflow-design',
    component: React.lazy(() => import('./workflow/components/design/WorkflowDesign')),
    scopes: [PERMISSIONS.WORKFLOW_CREATE]
  },
  {
    exact: true,
    path: '/workflow-design/:workflowId',
    component: React.lazy(() => import('./workflow/components/design/WorkflowDesign')),
    scopes: [PERMISSIONS.WORKFLOW_VIEW]
  },
  {
    exact: true,
    path: '/workflow-design/:workflowId/edit',
    component: React.lazy(() => import('./workflow/components/design/WorkflowDesign')),
    scopes: [PERMISSIONS.WORKFLOW_UPDATE]
  },
]

export default pagesRoutes
